import { UserStateContextType } from 'components/constants/Constants';
import { useUserState } from 'context/User';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

const PrivateRouteNew: React.FC<{
  component: JSX.Element;
}> = ({ component }) => {
  const userState = useUserState();
  const auth = useAuth();

  // Redirect to search page if user is signing out, because he won't have access to this private route anymore
  // It's only needed for signout silent which we don't use at the moment, but we keep this check here to not
  // break things in the future
  if (auth.activeNavigator === 'signoutSilent')
    return <Navigate to="/ingredients/search" />;

  switch (userState.type) {
    case UserStateContextType.LOADING:
      return null;
    case UserStateContextType.NOT_AUTHENTICATED:
      auth.signinRedirect({ redirect_uri: window.location.href });
      return null;
    case UserStateContextType.AUTHENTICATED: {
      // TODO implement permissionCheck
      return component;
    }
  }
};

export default PrivateRouteNew;
